import React, { createContext, useContext, useMemo } from 'react';
import { initializeApp, FirebaseApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore/lite';

const Context = createContext<FirebaseApp | undefined>(undefined);

export const FirebaseProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const app = useMemo(() => {
    const app = initializeApp({
      apiKey: 'AIzaSyDlGqXW0BLKUkLfxnISbpJ8txPcuAcUiQA',
      authDomain: 'userpath-sa.firebaseapp.com',
      projectId: 'userpath-sa',
      storageBucket: 'userpath-sa.appspot.com',
      messagingSenderId: '827778746526',
      appId: '1:827778746526:web:ed163ef4520b27e629138f',
      measurementId: 'G-XD5N8DJFKN',
    });
    initializeFirestore(app, {
      ignoreUndefinedProperties: true,
    });
    return app;
  }, []);
  return <Context.Provider value={app}>{children}</Context.Provider>;
};

export const useFirebaseApp = () => {
  const app = useContext(Context);
  if (!app)
    throw new Error(
      'No FirebaseProvider.Provider found when calling useFirebaseApp.',
    );
  return app;
};
